import React from 'react';

function HowtodoPayout() {
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_content">
               <h1>How to do Payout</h1>
               <hr />
               <p><b>Single Payout:</b></p>
               <p>To make a single payout, follow these steps:</p>
               <ul>
                  
                  <li>Login to your account and go to the "Payout" section.</li>
                  <li>Select "Single Payout transfer" and enter the beneficiary details like name, mobile number, transaction type, bank account number, IFSC code, email id, order ref number, etc.</li>
                  <li>Review the details and confirm the payout.</li>
                  <li>Once the payout is successful, the funds will be transferred to the beneficiary's account.</li>
               </ul>
               <p class="mt-30"><b>Bulk Payout:</b></p>
               <p>To make multiple payouts in a single transaction, follow these steps:</p>
               <ul>
                  <li>Login to your account and go to the "Payout" section.</li>
                  <li>Select "Bulk Payout File Uplaod" and upload a CSV file with the beneficiary details like amount, name, bank account number, IFSC code, payment type and order ref number.</li>
                  <li>User can download the sample file format from the same window.</li>
                  <li>On successful upload of the file, the file shall be processed with the validations.</li>
                  <li>Select “Bulk Upload Approval”, select the processed file and hit search</li>
                  <li>All the records will be fetched from the file can be reviewed before initiating the transaction.</li>
                  <li>User can approve or reject all the transaction one by one or in one go.</li>
                  <li>On the approval, the transaction shall be posted to the bank.</li>
                  <li>Once the payout is successful, the funds will be transferred to all the beneficiary's accounts.</li>
               </ul>
               <p class="mt-30">That's it! You can now easily add funds to your VA and make single or bulk payouts with just a few simple steps.</p>
               
               
               
               
              
            </section>
         </div>
         <div class="col-md-4">
         </div>
      </div>
      
     
   </div>
</div>
)
}
export default HowtodoPayout